import React from 'react';
import Svg, { ClipPath, Defs, G, Mask, Path, Rect } from 'react-native-svg';
import { Props } from '../SvgProps';

const SomethingWentWrong: React.FC<Props> = () => {
  return (
    <Svg width="171" height="128" viewBox="0 0 171 128" fill="none">
      <G clipPath="url(#clip0_468_8572)">
        <Path
          d="M32.75 1V8.73869"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <Path
          d="M28.9004 4.86719H36.6004"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <Path
          d="M52.75 6.22852C53.7165 6.22852 54.5 5.44108 54.5 4.46973C54.5 3.49837 53.7165 2.71094 52.75 2.71094C51.7835 2.71094 51 3.49837 51 4.46973C51 5.44108 51.7835 6.22852 52.75 6.22852Z"
          fill="#D9D9D9"
        />
        <Path
          d="M126.836 102.192C107.651 104.446 101.488 106.825 88.189 117.114C68.4404 132.388 38.9788 132.457 30.5541 103.241C24.0761 80.7714 30.3222 52.8929 44.6988 40.111C68.9075 18.5863 113.712 14.7377 141.522 31.3436C165.498 45.6575 173.203 73.1954 158.253 91.1418C153.182 97.2287 145.212 100.032 126.836 102.192Z"
          fill="#F4F4F4"
        />
        <Path
          d="M147.85 16.7109V24.4496"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <Path
          d="M144 20.5781H151.7"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <Path
          d="M165.85 93.7109V101.45"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <Path
          d="M162 97.5781H169.7"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <Path
          d="M160.75 120.229C161.716 120.229 162.5 119.442 162.5 118.47C162.5 117.499 161.716 116.711 160.75 116.711C159.784 116.711 159 117.499 159 118.47C159 119.442 159.784 120.229 160.75 120.229Z"
          fill="#D9D9D9"
        />
        <Path
          d="M94 114.906C121.062 114.906 143 92.9682 143 65.9062C143 38.8443 121.062 16.9062 94 16.9062C66.938 16.9062 45 38.8443 45 65.9062C45 92.9682 66.938 114.906 94 114.906Z"
          fill="#D9D9D9"
        />
        <Path
          d="M86.6018 102.138C111.506 102.138 131.694 81.9496 131.694 57.0457C131.694 32.1417 111.506 11.9531 86.6018 11.9531C61.6979 11.9531 41.5093 32.1417 41.5093 57.0457C41.5093 81.9496 61.6979 102.138 86.6018 102.138Z"
          fill="white"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M104.639 75.0849C104.639 75.0849 97.8746 66.0664 86.6015 66.0664C75.3284 66.0664 68.5645 75.0849 68.5645 75.0849"
          fill="white"
        />
        <Path
          d="M104.639 75.0849C104.639 75.0849 97.8746 66.0664 86.6015 66.0664C75.3284 66.0664 68.5645 75.0849 68.5645 75.0849"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M71.6606 43.7266H77.6428"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M95.5894 43.7266H101.572"
          stroke="#AFAFAF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Mask
          id="mask0_468_8572"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="121"
          y="96"
          width="30"
          height="23"
        >
          <Path d="M151 96.6758H121V118.676H151V96.6758Z" fill="white" />
        </Mask>
        <G mask="url(#mask0_468_8572)">
          <Path
            d="M143.5 117.301H131.909C126.632 117.301 122.364 112.983 122.364 107.676C122.364 102.355 126.645 98.0508 131.909 98.0508C136.136 98.0508 139.845 100.842 141.059 104.926H143.5C146.895 104.926 149.636 107.69 149.636 111.113C149.636 114.537 146.895 117.301 143.5 117.301Z"
            fill="white"
            stroke="#AFAFAF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </G>
        <Mask
          id="mask1_468_8572"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="24"
          width="32"
          height="31"
        >
          <Path d="M32 24.6758H0V54.6758H32V24.6758Z" fill="white" />
        </Mask>
        <G mask="url(#mask1_468_8572)">
          <Path
            d="M30.2982 35.1764C29.6872 33.3764 28.0291 32.1764 26.1818 32.1764H22.9672C21.76 27.7964 17.3381 25.2464 13.0909 26.4914C10.1091 27.3614 7.86906 29.9414 7.37451 33.0914"
            fill="white"
          />
          <Path
            d="M30.2982 35.1764C29.6872 33.3764 28.0291 32.1764 26.1818 32.1764H22.9672C21.76 27.7964 17.3381 25.2464 13.0909 26.4914C10.1091 27.3614 7.86906 29.9414 7.37451 33.0914"
            stroke="#AFAFAF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <Path
            d="M24 39.6758C27.6219 39.6758 30.5455 42.6908 30.5455 46.4258C30.5455 50.1608 27.6219 53.1758 24 53.1758H11.651C6.02186 53.1758 1.46914 48.4808 1.45459 42.6908C1.45459 36.8858 6.00732 32.1908 11.6219 32.1758C16.131 32.1758 20.1019 35.2208 21.3819 39.6758H23.9855H24Z"
            fill="white"
            stroke="#AFAFAF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </G>
      </G>
      <Defs>
        <ClipPath id="clip0_468_8572">
          <Rect width="171" height="128" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default SomethingWentWrong;